export default "__VITE_ASSET__BLIIbihx__"